<template> 
     <BaseModal
        :id="'static'"
        :title="title"
        :message="'Enter a Cleaning Code, Name, Production Standard, Inspection Frequency, Task type and select the Cleaning Steps to associate with the Task.'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_ext()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <div class="w-100 table-responsive defaultproject__table overflow-y--1" v-if="step_codes.length">
                    <table class="table">
                        <thead style="background-color: #f1f1f1;">
                            <tr>
                                <!-- <th>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`checkedMultiple`" type="checkbox" class="custom-control-input" v-model="step_code_multiple"/>
                                        <label :for="`checkedMultiple`" class="custom-control-label ml-2"/>
                                    </span>
                                </th> -->
                                <th v-for="(item, i) in step_table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in step_codes" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`checked${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                        <label :for="`checked${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td v-html="item.code"/>
                                <td v-html="item.name"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "array_options",
        "breadcrumb",
        "step_codes",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){

        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
            step_table_headers: Resources.step_table_headers,
            step_code_multiple: false,
        }
    },

    watch:{

        'form_data.special_task_type'(val)
        {
            if(val === '')
            {
                this.form_data.project = false
                this.form_data.policing = false
            }
            else if(val === 1)
            {
                this.form_data.project = true
                this.form_data.policing = false
            }
            else if(val === 2)
            {
                this.form_data.project = false
                this.form_data.policing = true
            }
        },

        step_code_multiple(val)
        {
            this.step_codes.map(item => item.checked = val)
        },

    },

    methods:{

        async form_submit_ext()
        {
            if(this.step_codes.length)
            {
                let step_codes = this.step_codes.filter( item => item.checked )
                
                this.form_data.step_code_id = step_codes.length ? step_codes.map(item => { return item.id }) : []
            }

            await this.form_submit()
            await this.form_data.step_code_id.splice(0, this.form_data.step_code_id.length)

            if(this.step_codes.length)
            {
                this.step_code_multiple = false
                this.step_codes.map(item => item.checked = this.step_code_multiple)
            }
        }

    },

    mounted(){

    }
    
}
</script>